import { TimeLogDetailDto } from '../../opportunity/dto'

import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type VolunteeringActivityDetails = TimeLogDetailDto & {
  accountId: string
  organisation: {
    id: string
    name: string
    logo: string | null
    countryCode: string | null
  } | null
  duringWorkingHours?: boolean
}

export const getVolunteeringActivity: QueryFn<[string, string], VolunteeringActivityDetails> = async (
  client,
  [_, timeLogId]
) => {
  const res = await client.get<{ data: VolunteeringActivityDetails }>(
    `v1/account/volunteering-time-logs/${timeLogId}`,
    {
      withCredentials: true
    }
  )

  return res.data.data
}
